module.exports = __webpack_public_path__ + "70c4a81af4b28454210d728586ba31d2.MP3";